import React from "react";
import LocalizedStrings from 'react-localization';
import { connect } from "react-redux";
import EditUser from "./EditUser";
import { localisedText } from "../../../../../lib/localisation.es6";
import {  resetDcpUpdateCustomer, updateDcpCustomerRequest } from "../RegisterCustomer/redux/actions";

class EditUserDcp extends React.Component {
  
  constructor(props) {
    const localizedStrings = new LocalizedStrings(localisedText);
    super(props);
    this.state = {
      labels: localizedStrings,
    }
  }


  componentWillMount() {
    this.updateLanguage();
  }
  componentDidUpdate() {
    this.updateLanguage();
  }

  updateLanguage() {
    const language = this.props.globalData.language;
    let resetLanguage = false;
    if (!language) {
      resetLanguage = true;
    }
    const labels = this.state.labels;
    if (resetLanguage || labels.getLanguage() !== language) {
      labels.setLanguage(language);
      this.setState({});
    }
  }

  editCustomer(payload) {
		this.props.dispatch(updateDcpCustomerRequest(payload))
	}
	resetAfterSucesfulyEdit() {
		this.props.dispatch(resetDcpUpdateCustomer());
	}

	resetAfterFailedEdit() {
		this.props.dispatch(resetDcpUpdateCustomer());
	}


  render() {

    console.log("this.props.DCPRegistrationData.", this.props.DCPRegistrationData)


      return (
        <>
        <EditUser
        labels={this.state.labels}
        openEditCustomerDialog={this.props.openEditCustomerDialog}
        toggleEditCustomerDialog={this.props.toggleEditCustomerDialog}
        customerData={this.props.customerData.currentCustomer}

        editCustomer={this.editCustomer.bind(this)}
        loader={this.props.DCPRegistrationData.edit_loader}
        customerEditedSuccessfully={this.props.DCPRegistrationData.customer_edited_succesfully}
        customerEditedFailed={this.props.DCPRegistrationData.customer_edited_failed}
        resetAfterSucesfulyEdit={this.resetAfterSucesfulyEdit.bind(this)}
        resetAfterFailedEdit={this.resetAfterFailedEdit.bind(this)}
        />
        </>
      )
  

  }

}

export default connect((state) => ({
  customerData: state.currentCustomer,
  DCPRegistrationData: state.DCPRegistrationData,
  userData: state.userAdmin,
  globalData: state.global,
}))(EditUserDcp);